import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { DprStatusTrackerReportModel } from '@report/models/dpr-status-tracker-report.model';
import { SubprojectConfigurationCustomNames } from '@shared/models/project-setup';

@Component({
  selector: 'app-report-status-tracker',
  templateUrl: './report-status-tracker.component.html',
  styleUrls: ['./report-status-tracker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportStatusTrackerComponent {
  @Input({ required: true })
  dprStatusTrackerModelReport: DprStatusTrackerReportModel;
  @Input({ required: true }) customNames: SubprojectConfigurationCustomNames;
}
